import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface NotificationData {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly notificationSubject: BehaviorSubject<NotificationData | null> = new BehaviorSubject<NotificationData | null>(null);
  public readonly notification$: Observable<NotificationData | null> = this.notificationSubject.asObservable();

  showSuccess(message: string, duration: number = 4000): void {
    this.show({
      message,
      type: 'success',
      duration,
    });
  }

  showError(message: string, duration: number = 4000): void {
    this.show({
      message,
      type: 'error',
      duration,
    });
  }

  showWarning(message: string, duration: number = 4000): void {
    this.show({
      message,
      type: 'warning',
      duration,
    });
  }

  showInfo(message: string, duration: number = 4000): void {
    this.show({
      message,
      type: 'info',
      duration,
    });
  }

  private show(notification: NotificationData): void {
    this.notificationSubject.next(notification);

    if (notification.duration && notification.duration > 0) {
      setTimeout(() => {
        this.hide();
      }, notification.duration);
    }
  }

  hide(): void {
    this.notificationSubject.next(null);
  }
}
